<script setup lang="ts">
import type { EpgWidgetParagraph } from '../../../../../utils/paragraph-schema/paragraphs'

type EpgWidget = EpgWidgetParagraph['epgWidget']
type ShortLink = NonNullable<NonNullable<EpgWidget['config']>['shortLink']>

defineProps<{
  headline?: string,
  shortLink?: ShortLink
}>()
</script>

<template>
  <section class="bx-search__header bx-typo--search-header bx-filters bx-filters--static">
    <div>
      <a :href="shortLink?.url"
         class="bx-js-active bx-typo--bold"
         :aria-label="`Zum heutigen Programm ${shortLink?.text}`">
        {{ shortLink?.text }}
      </a>
    </div>
    <h2 v-if="headline">
      {{ headline }}
    </h2>
  </section>
</template>
